
<template>
  <div class="scores-container">

  
    <div class="risk-score-card">
       <div id="tradingview-widget-container">
         <div id="tradingview-widget"></div><br>
         <button @click="clearLocalStorage">Clear Symbols</button>
       </div></div>    
  
  <h3>Your Watchlist</h3>
     <input v-model="newSymbol.symbol" placeholder="Exchange:Symbol" />
     <input v-model="newSymbol.description" placeholder="Description (optional)" />
     <button @click="addSymbol">Add</button>
    </div>
<br>
         <!-- Modal for error message -->
 <div v-if="showErrorModal" class="modal">
   <div class="modal-content">
     <span class="close" @click="showErrorModal = false">&times;</span>
     <p>Oops... RiskyPaws is working on this</p>
     </div>
   </div>
 <br><br><br><br>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { nextTick } from 'vue';

export default {
 setup() {
   const newSymbol = ref({ symbol: '', description: '' });
   const watchList = ref(JSON.parse(localStorage.getItem('watchList')) || []);
   const showErrorModal = ref(false);

   // Watch for changes in watchList and update local storage
   watch(watchList, (newList) => {
     localStorage.setItem('watchList', JSON.stringify(newList));
     updateWidget(); // Update the widget with new watchList
   }, { deep: true });

   const addSymbol = () => {
     watchList.value.push({ 
       s: newSymbol.value.symbol, 
       d: newSymbol.value.description 
     });
     newSymbol.value = { symbol: '', description: '' }; // Reset form
   };

   const updateWidget = () => {
     nextTick(() => {
       const container = document.getElementById('tradingview-widget');
       if (container) {
         container.innerHTML = '';

         // Create script for TradingView widget
         const script = document.createElement('script');
         script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js';
         script.async = true;
         script.innerHTML = JSON.stringify({
           "symbols": watchList.value.map(symbol => [symbol.d, symbol.s]),
           "chartOnly": false,
 "width": "320",
 "height": 500,
 "locale": "en",
 "colorTheme": "light",
 "autosize": false,
 "showVolume": false,
 "showMA": false,
 "hideDateRanges": false,
 "hideMarketStatus": false,
 "hideSymbolLogo": false,
 "scalePosition": "right",
 "scaleMode": "Normal",
 "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
 "fontSize": "10",
 "noTimeScale": false,
 "valuesTracking": "1",
 "changeMode": "price-and-percent",
 "chartType": "candlesticks",
 "maLineColor": "#2962FF",
 "maLineWidth": 1,
 "maLength": 9,
 "lineType": 0,
 "dateRanges": [
   "1d|1",
   "1m|30",
   "3m|60",
   "12m|1D",
   "60m|1W",
   "all|1M"
 ],

           "dateFormat": "yyyy-MM-dd",
 "timeHoursFormat": "12-hours",
 "upColor": "rgba(81, 45, 168, 1)",
 "downColor": "rgba(209, 196, 233, 1)",
 "borderUpColor": "#22ab94",
 "borderDownColor": "#f7525f",
 "wickUpColor": "#22ab94",
 "wickDownColor": "#f7525f"

         });
         container.appendChild(script);
       }
     });
   };

   const clearLocalStorage = () => {
     try {
       localStorage.removeItem('watchList');
       watchList.value = []; 
       updateWidget(); 
     } catch (error) {
       console.error('Error clearing local storage:', error);
       showErrorModal.value = true; 
     }
   };

   onMounted(updateWidget);

   return {
     newSymbol,
     addSymbol,
     clearLocalStorage,
     showErrorModal, 
   };
 },
};
</script>

<style scoped>

.scores-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #36454f;
  color: white;
  border: 2px solid #4A148C;
  border-radius: 10px;
}

.risk-score-card h3 {
  text-align: center;
  margin-bottom: 20px;
}

.input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.styled-input {
  width: 80%;
  max-width: 400px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.add-symbol-form button, #tradingview-widget-container button {
  background-color: #4A148C;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.add-symbol-form button:hover, #tradingview-widget-container button:hover {
  background-color: black;
}

.tradingview-widget-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.modal {
  display: none; /* Change to block when modal is active */
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 300px;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  cursor: pointer;
}

button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}

/* Adjustments for smaller screens */
@media (max-width: 768px) {
  .input-container {
    flex-direction: column;
    align-items: center;
  }

  .styled-input, .add
-symbol-form button, #tradingview-widget-container button {
width: 90%; /* Full width for small screens */
}

.tradingview-widget-container {
margin-top: 10px;
}
}

</style>
